import React, { useEffect, useState } from "react";
import { Country } from "country-state-city";
import currencyCodes from "currency-codes";
import {
  Flex,
  Box,
  Grid,
  Checkbox,
  Heading,
  Divider,
  GridItem,
  Text,
  VStack,
} from "@chakra-ui/react";
import CustomInput from "components/common/customInput/CustomInput";
import { paymentTerm } from "./utils/variable";

export default function FinanceOnboardingForm({
  values,
  setValues,
  accountGroup,
  reconAccountMumbai,
  reconcillationAccount,
  taxHolding,
  vendorSchema,
  whTypeInvoice,
  whTypeInvoiceBase,
  WHTypePayment,
  WHTypePaymentBase,
  PurchaseOrg,
  TransRoute,
  locations,
  dueDates,
  paymentTermData
}: any) {
  const [currency, setCurrency] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [purchaseOrgOptions, setPurchaseOrgOptions] = useState([]);

  // useEffect(() => {
  //   if (values?.companyListCode) {
  //     const matchingPurchaseOrgs = PurchaseOrg.filter(
  //       (org: any) => org.CompanyCode === Number(values.companyListCode)
  //     );

  //     if (matchingPurchaseOrgs.length > 0) {
  //       setValues((prevValues: any) => ({
  //         ...prevValues,
  //         purchaseOrganizationCode: matchingPurchaseOrgs.map(
  //           (org: any) => org.Porg
  //         ),
  //         purchaseOrganizationDesc: matchingPurchaseOrgs.map(
  //           (org: any) => org.Description
  //         ),
  //       }));
  //     }
  //   }
  // }, [values?.companyListCode]);

  const filterByCompanyCode = (companyListCode: string) => {
    return PurchaseOrg.filter(
      (org: any) => org.CompanyCode === Number(companyListCode)
    );
  };

  useEffect(() => {
    if (values?.companyListCode) {
      const result = filterByCompanyCode(values?.companyListCode);
      setPurchaseOrgOptions(result);
    }
  }, [values?.companyListCode]);


  useEffect(() => {
    setValues((prevValues: any) => ({
      ...prevValues,
      purchaseOrganizationCode: values?.purchaseOrganizationDesc?.value,
    }));
  }, [values?.purchaseOrganizationDesc]);

  useEffect(() => {
    setValues((prevValues: any) => ({
      ...prevValues,
      transRoute: values?.transRouteDesc?.value,
    }));
  }, [values?.transRouteDesc]);



  // Initialize currency options
  useEffect(() => {
    const countries = Country.getAllCountries();
    const countriesWithCurrencyName = countries.map((country: any) => {
      const currencyName =
        currencyCodes.code(country.currency)?.currency || "Unknown";
      return {
        label: country.currency,
        value: country.currency,
        description: currencyName,
      };
    });
    setCurrency(countriesWithCurrencyName);
  }, []);

  // Sync derived values
  useEffect(() => {
    setValues((prevValues: any) => ({
      ...prevValues,
      taxCountryCode: values?.taxCountryName?.value || "",
    }));
  }, [values?.taxCountryName, setValues]);

  useEffect(() => {
    setValues((prevValues: any) => ({
      ...prevValues,
      currency: values?.currencyName?.value || "",
    }));
  }, [values?.currencyName, setValues]);

  useEffect(() => {
    setValues((prevValues: any) => ({
      ...prevValues,
      accountGroupCode: values?.accountGroupDesc?.value || "",
    }));
  }, [values?.accountGroupDesc, setValues]);

  useEffect(() => {
    setValues((prevValues: any) => ({
      ...prevValues,
      reconCode: values?.reconDesc?.value || "",
    }));
  }, [values?.reconDesc, setValues]);

    useEffect(() => {
    setValues((prevValues: any) => ({
      ...prevValues,
      paymentTermCode: values?.paymentTermDesc?.value || "",
    }));
  }, [values?.paymentTermDesc, setValues]);


  useEffect(() => {
    setValues((prevValues: any) => ({
      ...prevValues,
      taxTypeInvCode: values?.taxTypeInvDesc?.value || "",
    }));
  }, [values?.taxTypeInvDesc, setValues]);

  useEffect(() => {
    setValues((prevValues: any) => ({
      ...prevValues,
      taxCodeInv: values?.taxCodeInvDesc?.value || "",
    }));
  }, [values?.taxCodeInvDesc, setValues]);

  useEffect(() => {
    setValues((prevValues: any) => ({
      ...prevValues,
      taxPaymentCode: values?.taxPaymentDesc?.value || "",
    }));
  }, [values?.taxPaymentDesc, setValues]);

  useEffect(() => {
    setValues((prevValues: any) => ({
      ...prevValues,
      vendorSchema: values?.vendorSchemaDesc?.value || "",
    }));
  }, [values?.vendorSchemaDesc, setValues]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, type, checked, value } = event.target;
    const finalValue = type === "checkbox" ? checked : value;

    setValues((prevValues: any) => {
      if (name?.includes(".")) {
        const keys = name?.split(".");
        let updatedValues = { ...prevValues };

        let current: any = updatedValues;
        keys.forEach((key, index) => {
          if (index === keys.length - 1) {
            current[key] = finalValue;
          } else {
            current[key] = current[key] ? { ...current[key] } : {};
            current = current[key];
          }
        });

        return updatedValues;
      } else {
        return { ...prevValues, [name]: finalValue };
      }
    });
  };

  const handleSelectChange = (selectedObject: any, field: string) => {
    setValues((prevValues: any) => ({
      ...prevValues,
      [field]: selectedObject,
    }));
  };

  const handlePurchaseOrgChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = event.target;
    setValues((prevValues: any) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  useEffect(() => {
    setValues((prevValues: any) => ({
      ...prevValues,
      clerkAbLocationCode: values?.clerkAbLocation?.value,
    }));
  }, [values?.clerkAbLocation]);

  useEffect(() => {
    setValues((prevValues: any) => ({
      ...prevValues,
      dueDateCode: values?.dueDate?.value,
    }));
  }, [values?.dueDate]);

  console.log("the values are", values);

  const SectionHeader = ({ title }: { title: string }) => (
    <Box my={6}>
      <Heading size="md" color="gray.700" fontWeight="semibold" mb={3}>
        {title}
      </Heading>
      <Divider borderColor="gray.300" />
    </Box>
  );


  return (
    <Box p={{ base: 4, md: 4 }} borderRadius="lg" maxW="1200px" mx="auto">
      {isLoading && (
        <Box textAlign="center" py={4} color="gray.500">
          Loading...
        </Box>
      )}

      <VStack spacing={6} align="stretch">
        <Grid templateColumns={{ lg: "2fr 1fr" }} gap={6} my={2}>
          <CustomInput
            type="select"
            label="Select Clerk Abbreviation Location"
            name="clerkAbLocation"
            floating={true}
            value={locations?.find(
              (option: any) => option.value === values.clerkAbLocation?.value
            )}
            options={locations?.map((account: any) => ({
              label: account.label,
              value: account.value,
            }))}
            isBoxSelect
            onChange={(e: any) => handleSelectChange(e, "clerkAbLocation")}
            // options={locations}
            isRequired={false}
          />
          <CustomInput
            type="text"
            label="Clerk Code"
            name="clerkAbLocationCode"
            value={values?.clerkAbLocationCode}
            onChange={handleChange}
            isRequired={true}
            floating={true}
          />
        </Grid>

        <Grid templateColumns={{ base: "1fr", md: "2fr 1fr" }} gap={4}>
          {/* <CustomInput
            name="purchaseOrganizationDesc"
            value={
              values?.purchaseOrganizationDesc
                ? values?.purchaseOrganizationDesc?.join(", ") || ""
                : ""
            }
            onChange={handlePurchaseOrgChange}
            label="Purchase Org Description"
            type="text"
            floating={true}
            isReadOnly={true}
          />
          <CustomInput
            name="purchaseOrganizationCode"
            value={
              values?.purchaseOrganizationCode
                ? values?.purchaseOrganizationCode?.join(", ") || ""
                : ""
            }
            onChange={handlePurchaseOrgChange}
            label="Purchase Org Code"
            type="text"
            floating={true}
            isReadOnly={true}
          /> */}
          <CustomInput
            type="select"
            label="Select Purchase Org Description"
            name="purchaseOrganizationDesc"
            floating={true}
            value={purchaseOrgOptions?.find(
              (option: any) =>
                option.Description ===
                values.purchaseOrganizationDesc?.Description
            )}
            options={purchaseOrgOptions?.map((org: any) => ({
              label: org.Description,
              value: org.Porg,
            }))}
            isBoxSelect
            onChange={(e: any) =>
              handleSelectChange(e, "purchaseOrganizationDesc")
            }
            // options={locations}
            isRequired={false}
          />
          <CustomInput
            type="number"
            label="Purchase Org Code"
            name="purchaseOrganizationCode"
            value={values?.purchaseOrganizationCode}
            onChange={handleChange}
            isRequired={true}
            floating={true}
          />
        </Grid>

        <Grid templateColumns={{ base: "1fr", md: "2fr 1fr 2fr 1fr" }} gap={4}>

          <GridItem colSpan={{ base: 1, md: 2 }}>
            <CustomInput
              type="select"
              name="paymentTermDesc"
              label="Payment Term Description"
              value={paymentTermData?.find(
                (option: any) => option.value === values.paymentTermDesc?.value
              )}
              isBoxSelect
              onChange={(e: any) => {
                handleSelectChange(e, "paymentTermDesc");
              }}
              options={paymentTermData?.map((account: any) => ({
                label: account.description,
                value: account.value,
              }))}
              floating={true}
              isRequired={true}
            />
          </GridItem>
          <GridItem>
            <CustomInput
              name="paymentTermCode"
              value={values.paymentTermCode || ""}
              onChange={handleChange}
              label="Payment Term"
              type="text"
              floating={true}
            />
          </GridItem>
          <GridItem colSpan={{ base: 1, md: 2 }}>
            <CustomInput
              type="select"
              name="accountGroupDesc"
              label="Account Group Description"
              value={accountGroup?.find(
                (option: any) => option.value === values.accountGroupDesc?.value
              )}
              isBoxSelect
              onChange={(e: any) => {
                setValues((values: any) => ({
                  ...values,
                  esi: false,
                  pf: false,
                }));
                handleSelectChange(e, "accountGroupDesc");
              }}
              options={accountGroup?.map((account: any) => ({
                label: account.description,
                value: account.value,
              }))}
              floating={true}
              isRequired={true}
            />
          </GridItem>
          <GridItem>
            <CustomInput
              name="accountGroupCode"
              value={values.accountGroupCode || ""}
              onChange={handleChange}
              label="Account Group"
              type="text"
              floating={true}
            />
          </GridItem>
          <GridItem colSpan={{ base: 1, md: 2 }}>
            <CustomInput
              type="select"
              name="reconDesc"
              label="Reconciliation Account Description"
              value={(values?.clerkAbLocation?.value === "MU"
                ? reconAccountMumbai
                : reconcillationAccount
              )?.find(
                (option: any) => option.value === values.reconDesc?.value
              )}
              isBoxSelect
              onChange={(e: any) => handleSelectChange(e, "reconDesc")}
              options={(values?.clerkAbLocation?.value === "MU"
                ? reconAccountMumbai
                : reconcillationAccount
              )?.map((option: any) => ({
                label: option.description,
                value: option.value,
              }))}
              floating={true}
            />
          </GridItem>
          <GridItem>
            <CustomInput
              name="reconCode"
              value={values.reconCode || ""}
              onChange={handleChange}
              label="Recon Acc"
              type="text"
              floating={true}
            />
          </GridItem>
        </Grid>
      </VStack>

      {/* Payment Details Section */}
      <SectionHeader title="Payment Details" />
      <Grid templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }} gap={4}>
        <CustomInput
          name="sortKey"
          value={values.sortKey || ""}
          onChange={handleChange}
          label="Sort Key"
          type="text"
          isRequired
          floating={true}
          isReadOnly={true}
        />
        <CustomInput
          type="select"
          label="Select Payment Term"
          name="paymentTerms"
          isBoxSelect={true}
          value={paymentTerm?.find(
            (option: { label: string; value: string; description: string }) =>
              option.value === values?.paymentTerms?.value
          )}
          onChange={(e: any) => {
            handleSelectChange(e, "paymentTerms");
          }}
          options={paymentTerm.map((term: any) => ({
            label: term?.description,
            value: term?.value,
          }))}
          floating
        />
        <CustomInput
          name="paymentMethod"
          value={values.paymentMethod || ""}
          onChange={handleChange}
          label="Payment Method"
          type="text"
          isRequired
          floating={true}
          isReadOnly={true}
        />
        <Flex alignItems="center">
          <Checkbox
            name="doubleInvoice"
            colorScheme="teal"
            isChecked={values.doubleInvoice || false}
            onChange={handleChange}
            isRequired={true}
            size="lg"
          >
            <Text fontSize="sm" color="gray.600">
              Double Invoice
            </Text>
          </Checkbox>
        </Flex>
        {values.accountGroupCode === "YB02" && (
          <>
            <GridItem>
              <Flex alignItems="center">
                <Checkbox
                  name="pf"
                  colorScheme="teal"
                  isChecked={values.pf || false}
                  onChange={handleChange}
                  size="lg"
                >
                  <Text fontSize="sm" color="gray.600">
                    PF
                  </Text>
                </Checkbox>
              </Flex>
            </GridItem>
            <GridItem>
              <Flex alignItems="center">
                <Checkbox
                  name="esi"
                  colorScheme="teal"
                  isChecked={values.esi || false}
                  onChange={handleChange}
                  size="lg"
                >
                  <Text fontSize="sm" color="gray.600">
                    ESI
                  </Text>
                </Checkbox>
              </Flex>
            </GridItem>
          </>
        )}
      </Grid>

      {/* Tax Information Section */}
      <SectionHeader title="Tax Information" />
      <Grid templateColumns={{ base: "1fr", md: "repeat(4, 1fr)" }} gap={6}>
        <GridItem colSpan={{ base: 1, md: 2 }}>
          <CustomInput
            type="select"
            name="taxCountryName"
            label="WH Tax Country Name"
            value={taxHolding?.find(
              (option: any) => option.value === values.taxCountryName?.value
            )}
            isBoxSelect
            onChange={(e: any) => handleSelectChange(e, "taxCountryName")}
            options={taxHolding?.map((option: any) => ({
              label: option.description,
              value: option.value,
            }))}
            floating={true}
          />
        </GridItem>
        <GridItem>
          <CustomInput
            name="taxCountryCode"
            value={values.taxCountryCode || ""}
            onChange={handleChange}
            label="WH Tax Country"
            type="text"
            floating={true}
          />
        </GridItem>
        <GridItem colSpan={{ base: 1, md: 2 }}>
          <CustomInput
            type="select"
            name="taxTypeInvDesc"
            label="WH Type - Invoice Description"
            value={(values?.accountGroupCode === "YB01" ||
            values?.accountGroupCode === "YB12"
              ? whTypeInvoiceBase
              : whTypeInvoice
            )?.find(
              (option: any) => option.value === values.taxTypeInvDesc?.value
            )}
            isBoxSelect
            onChange={(e: any) => handleSelectChange(e, "taxTypeInvDesc")}
            options={(values?.accountGroupCode === "YB01" ||
            values?.accountGroupCode === "YB12"
              ? whTypeInvoiceBase
              : whTypeInvoice
            )?.map((option: any) => ({
              label: option.description,
              value: option.value,
            }))}
            floating={true}
          />
        </GridItem>
        <GridItem>
          <CustomInput
            name="taxTypeInvCode"
            value={values.taxTypeInvCode || ""}
            onChange={handleChange}
            label="WH Type - Invoice"
            type="text"
            floating={true}
          />
        </GridItem>
        <GridItem colSpan={{ base: 1, md: 2 }}>
          <CustomInput
            type="select"
            name="taxCodeInvDesc"
            label="WH Code - Invoice Description"
            value={(values?.accountGroupCode === "YB01" ||
            values?.accountGroupCode === "YB12"
              ? whTypeInvoiceBase
              : whTypeInvoice
            )?.find(
              (option: any) => option.value === values.taxCodeInvDesc?.value
            )}
            isBoxSelect
            onChange={(e: any) => handleSelectChange(e, "taxCodeInvDesc")}
            options={(values?.accountGroupCode === "YB01" ||
            values?.accountGroupCode === "YB12"
              ? whTypeInvoiceBase
              : whTypeInvoice
            )?.map((option: any) => ({
              label: option.description,
              value: option.value,
            }))}
            floating={true}
          />
        </GridItem>
        <GridItem>
          <CustomInput
            name="taxCodeInv"
            value={values.taxCodeInv || ""}
            onChange={handleChange}
            label="WH Code - Invoice"
            type="text"
            floating={true}
          />
        </GridItem>
        <GridItem>
          <Flex alignItems="center">
            <Checkbox
              name="taxInvLiable"
              colorScheme="teal"
              isChecked={values.taxInvLiable || false}
              onChange={handleChange}
              size="lg"
            >
              <Text fontSize="sm" color="gray.600">
                Invoice Liable
              </Text>
            </Checkbox>
          </Flex>
        </GridItem>
        <GridItem colSpan={{ base: 1, md: 2 }}>
          <CustomInput
            type="select"
            name="taxPaymentDesc"
            label="WH Payment Description"
            value={(values?.accountGroupCode === "YB01" ||
            values?.accountGroupCode === "YB12"
              ? WHTypePaymentBase
              : WHTypePayment
            )?.find(
              (option: any) => option.value === values.taxPaymentDesc?.value
            )}
            isBoxSelect
            onChange={(e: any) => handleSelectChange(e, "taxPaymentDesc")}
            options={(values?.accountGroupCode === "YB01" ||
            values?.accountGroupCode === "YB12"
              ? WHTypePaymentBase
              : WHTypePayment
            )?.map((option: any) => ({
              label: option.description,
              value: option.value,
            }))}
            floating={true}
          />
        </GridItem>
        <GridItem>
          <CustomInput
            name="taxPaymentCode"
            value={values.taxPaymentCode || ""}
            onChange={handleChange}
            label="WH Payment Code"
            type="text"
            floating={true}
          />
        </GridItem>
        <GridItem>
          <Flex alignItems="center">
            <Checkbox
              name="taxPaymentLiable"
              colorScheme="teal"
              isChecked={values.taxPaymentLiable || false}
              onChange={handleChange}
              size="lg"
            >
              <Text fontSize="sm" color="gray.600">
                Payment Liable
              </Text>
            </Checkbox>
          </Flex>
        </GridItem>
      </Grid>

      {/* Transport Route */}
      <Grid templateColumns={{ base: "1fr", md: "2fr 1fr" }} gap={4} mt={6}>
        <CustomInput
          type="select"
          name="transRouteDesc"
          label="Transport Route Description"
          value={values?.transRouteDesc}
          isBoxSelect
          onChange={(e: any) => handleSelectChange(e, "transRouteDesc")}
          options={TransRoute?.map((Route: any) => ({
            label: Route?.description,
            value: Route?.value,
          }))}
          floating={true}
          // getOptionLabel={(option : any) => option?.description || option?.label}
          // getOptionValue={(option : any) => option.value}
        />
        <CustomInput
          name="transRoute"
          value={values.transRoute}
          onChange={handleChange}
          label="Transport Route"
          type="text"
          floating={true}
        />
      </Grid>

      {/* Date Pickers */}
      <Grid templateColumns={{ lg: "1fr 1fr 1fr 1fr" }} gap={6} my={6}>
        <CustomInput
          type="select"
          label="Select Due Date"
          name="dueDate"
          floating={true}
          isBoxSelect
          value={values?.dueDate}
          onChange={(e: any) => handleSelectChange(e, "dueDate")}
          options={dueDates?.map((Route: any) => ({
            label: Route?.description,
            value: Route?.value,
          }))}
          isRequired={false}
        />
        <CustomInput
          type="text"
          label="Due Date Code"
          name="dueDateCode"
          value={values?.dueDateCode}
          onChange={handleChange}
          isRequired={false}
          floating={true}
        />
      </Grid>

      {/* Purchase Section */}
      <SectionHeader title="Purchase Information" />
      <Flex alignItems="center" mb={4}>
        <Checkbox
          name="purchase"
          colorScheme="teal"
          isChecked={values.purchase || false}
          onChange={handleChange}
          size="lg"
        >
          <Text fontSize="sm" color="gray.600">
            Enable Purchase View
          </Text>
        </Checkbox>
      </Flex>

      {values?.purchase && (
        <Grid templateColumns={{ base: "1fr", md: "repeat(4, 1fr)" }} gap={4}>
          <GridItem colSpan={{ base: 1, md: 2 }}>
            <CustomInput
              type="select"
              name="currencyName"
              label="Currency Name"
              value={currency?.find(
                (option: any) => option.value === values.currencyName?.value
              )}
              isBoxSelect
              onChange={(e: any) => handleSelectChange(e, "currencyName")}
              options={currency?.map((option: any) => ({
                label: option.description,
                value: option.value,
              }))}
              floating={true}
            />
          </GridItem>
          <GridItem>
            <CustomInput
              name="currency"
              value={values.currency || ""}
              onChange={handleChange}
              label="Currency"
              type="text"
              floating={true}
            />
          </GridItem>
          <GridItem colSpan={{ base: 1, md: 2 }}>
            <CustomInput
              type="select"
              name="vendorSchemaDesc"
              label="Vendor Schema"
              value={vendorSchema?.find(
                (option: any) => option.value === values.vendorSchemaDesc?.value
              )}
              isBoxSelect
              onChange={(e: any) => handleSelectChange(e, "vendorSchemaDesc")}
              options={vendorSchema?.map((option: any) => ({
                label: option.description,
                value: option.value,
              }))}
              floating={true}
            />
          </GridItem>
          <GridItem>
            <CustomInput
              name="vendorSchema"
              value={values.vendorSchema || ""}
              onChange={handleChange}
              label="Schema Code"
              type="text"
              floating={true}
            />
          </GridItem>
          <GridItem>
            <Flex alignItems="center">
              <Checkbox
                name="grBasedIV"
                colorScheme="teal"
                isChecked={values.grBasedIV || false}
                onChange={handleChange}
                size="lg"
              >
                <Text fontSize="sm" color="gray.600">
                  GR Based IV
                </Text>
              </Checkbox>
            </Flex>
          </GridItem>
        </Grid>
      )}
    </Box>
  );
}
